import { I18n } from 'lib/i18n'
import { del, get, patch, post } from 'lib/utilities'
import { toast } from 'react-toastify'

export const LOAD_PROPERTIES = 'properties/LOAD_PROPERTIES'
export const LOAD_DONE = 'properties/LOAD_DONE'
export const LOAD_FAILED = 'properties/LOAD_FAILED'
export const SELECT_PROPERTY = 'properties/SELECT_PROPERTY'

export const SAVE_PROPERTY = 'properties/SAVE_PROPERTY'
export const SAVE_DONE = 'properties/SAVE_DONE'
export const SAVE_FAILED = 'properties/SAVE_FAILED'

export const DELETE_PROPERTY = 'properties/DELETE_PROPERTY'
export const DELETE_PROPERTY_DONE = 'properties/DELETE_PROPERTY_DONE'
export const DELETE_PROPERTY_FAILED = 'properties/DELETE_PROPERTY_FAILED'

export const SAVE_VALUE = 'properties/SAVE_VALUE'
export const SAVE_VALUE_DONE = 'properties/SAVE_VALUE_DONE'
export const SAVE_VALUE_FAILED = 'properties/SAVE_VALUE_FAILED'

export const DELETE_VALUE = 'properties/DELETE_VALUE'
export const DELETE_VALUE_DONE = 'properties/DELETE_VALUE_DONE'
export const DELETE_VALUE_FAILED = 'properties/DELETE_VALUE_FAILED'

// action creators
export const loadProperties = () => ({ type: LOAD_PROPERTIES })
export const loadPropertiesFulfilled = (properties) => ({
  type: LOAD_DONE,
  properties,
})
export const loadPropertiesFailed = (errors) => ({ type: LOAD_FAILED, errors })

export const selectProperty = (propertyId) => ({
  type: SELECT_PROPERTY,
  propertyId: Number.parseInt(propertyId, 10),
})

export const saveProperty = (property) => ({ type: SAVE_PROPERTY, property })
export const savePropertyFulfilled = () => ({ type: SAVE_DONE })
export const savePropertyFailed = (errors) => ({ type: SAVE_FAILED, errors })

export const deleteProperty = (id) => ({ type: DELETE_PROPERTY, id })
export const deletePropertyFulfilled = () => ({ type: DELETE_PROPERTY_DONE })
export const deletePropertyFailed = () => ({ type: DELETE_PROPERTY_FAILED })

export const saveValue = (value) => ({ type: SAVE_VALUE, value })
export const saveValueFulfilled = () => ({ type: DELETE_VALUE_DONE })
export const saveValueFailed = () => ({ type: DELETE_VALUE_FAILED })

export const deleteValue = (id) => ({ type: DELETE_VALUE, id })
export const deleteValueFulfilled = () => ({ type: DELETE_VALUE_DONE })
export const deleteValueFailed = (errors) => ({
  type: DELETE_VALUE_FAILED,
  errors,
})

const initialState = {
  properties: [],
}

export const propertyReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PROPERTIES:
      return { ...state, propertiesLoading: true }
    case SELECT_PROPERTY:
      return { ...state, selectedPropertyId: action.propertyId }
    case LOAD_DONE:
      return {
        ...state,
        properties: action.properties,
        propertiesLoading: false,
      }

    case SAVE_PROPERTY:
      return { ...state, propertySaving: true }
    case SAVE_DONE:
      return { ...state, propertySaving: false }

    case SAVE_VALUE:
      return { ...state, valueSaving: true }

    case SAVE_VALUE_DONE:
      return { ...state, valueSaving: false }
    default:
      return state
  }
}

export const loadEpic = (action$, store) =>
  action$
    .ofType(LOAD_PROPERTIES)
    .mergeMap((action) => get('/properties.json'))
    .mergeMap((result) => {
      if (result.ok) {
        return [loadPropertiesFulfilled(result.body)]
      } else {
        toast.error(I18n.t(`action.${LOAD_FAILED}`))
        return [loadPropertiesFailed(result.body.errors)]
      }
    })

export const savePropertyEpic = (action$, store) =>
  action$
    .ofType(SAVE_PROPERTY)
    .filter((action) => action.property.id !== undefined)
    .mergeMap((action) =>
      patch('/properties/' + action.property.id, { property: action.property })
    )
    .mergeMap((result) => {
      if (result.ok) {
        return [savePropertyFulfilled(), loadProperties()]
      } else {
        toast.error(I18n.t(`action.${SAVE_FAILED}`))
        return [savePropertyFailed(result.body.errors)]
      }
    })

export const createPropertyEpic = (action$, store) =>
  action$
    .ofType(SAVE_PROPERTY)
    .filter((action) => action.property.id === undefined)
    .mergeMap((action) =>
      post('/properties.json', { property: action.property })
    )
    .mergeMap((result) => {
      if (result.ok) {
        return [savePropertyFulfilled(), loadProperties()]
      } else {
        toast.error(I18n.t(`action.${SAVE_FAILED}`))
        return [savePropertyFailed(result.body.errors)]
      }
    })

export const deletePropertyEpic = (action$, store) =>
  action$
    .ofType(DELETE_PROPERTY)
    .mergeMap((action) => del('/properties/' + action.id))
    .mergeMap((result) => {
      if (result.ok) {
        return [deletePropertyFulfilled(), loadProperties()]
      } else {
        toast.error(I18n.t(`action.${DELETE_PROPERTY_FAILED}`))
        return [deletePropertyFailed(result.body.errors)]
      }
    })

export const savePropertyValueEpic = (action$, store) =>
  action$
    .ofType(SAVE_VALUE)
    .filter((action) => action.value.id !== undefined)
    .mergeMap((action) =>
      patch('/property_values/' + action.value.id, {
        property_value: action.value,
      })
    )
    .mergeMap((result) => {
      if (result.ok) {
        return [saveValueFulfilled(), loadProperties()]
      } else {
        toast.error(I18n.t(`action.${SAVE_VALUE_FAILED}`))
        return [saveValueFailed(result.body.errors)]
      }
    })

export const createPropertyValueEpic = (action$, store) =>
  action$
    .ofType(SAVE_VALUE)
    .filter((action) => action.value.id === undefined)
    .mergeMap((action) =>
      post('/property_values.json', { property_value: action.value })
    )
    .mergeMap((result) => {
      if (result.ok) {
        return [saveValueFulfilled(), loadProperties()]
      } else {
        toast.error(I18n.t(`action.${SAVE_VALUE_FAILED}`))
        return [saveValueFailed(result.body.errors)]
      }
    })

export const deletePropertyValueEpic = (action$, store) =>
  action$
    .ofType(DELETE_VALUE)
    .mergeMap((action) => del('/property_values/' + action.id))
    .mergeMap((result) => {
      if (result.ok) {
        return [deleteValueFulfilled(), loadProperties()]
      } else {
        toast.error(I18n.t(`action.${DELETE_VALUE_FAILED}`))
        return [deleteValueFailed(result.body.errors)]
      }
    })



// WEBPACK FOOTER //
// ./src/redux/properties.js